import { T } from "../../localization";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header";

interface LoginProps {}

interface LoginState {}

class Login extends React.Component<LoginProps, LoginState> {
  state = {};
  render() {
    return (
      <div>
        <Header></Header>

        <div className="container">
          <div>
            <div className="form-title"><T text="Login" /></div>

            <div className="bookish-input-group">
              <p className="bookish-input-label">
                <T text="Email Address" /> <span className="required">*</span>
              </p>
              <input type="text" className="bookish-input-field" />
            </div>

            <div className="bookish-input-group">
              <p className="bookish-input-label">
                <T text="Password" /> <span className="required">*</span>
              </p>
              <input type="password" className="bookish-input-field" />
            </div>

            <div className="bookish-input-group mt-4">
              <button className="bookish-primary-btn"><T text="Login" /></button>
            </div>

            <div className="bookish-input-group">
              <Link to="/signup">
                <button className="bookish-secondary-btn"><T text="Create" /></button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
